export default "__VITE_ASSET__aea68163__"